//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { AMBASSADORS_ACCESS_PERMISSION } from '@campaigns/constants/AmbassadorsPermissions';
import { CampaignsStateFactory } from '@campaigns/routes/stateFactory';
import { hasPermissionForTask } from '@services/permissions';

import {
  componentNameToTemplate,
  hasFeature,
} from 'app/initialization/routing/stateHelpers';

// TODO: PD-329858 - Remove once VibeAmbassadorsPermission is fully released to all
// clients. While the flag is off for a client, access stays open to everyone (legacy
// behavior) so existing Ambassador users aren't suddenly locked out. Once the flag is
// on for a client, access is restricted to users with the ambassadors:access permission.
const hasAmbassadorsAccess = () =>
  !hasFeature(FeatureNames.VibeAmbassadorsPermission) ||
  hasPermissionForTask(AMBASSADORS_ACCESS_PERMISSION);

export const ambassadorStates = {
  'campaigns.ambassadors-community': CampaignsStateFactory({
    data: {
      hasAccess: () =>
        hasFeature(FeatureNames.VibeAmbassadors) && hasAmbassadorsAccess(),
      title: 'Campaigns: Ambassadors Community',
    },
    url: '/ambassadors/community',
    views: {
      main: {
        template: componentNameToTemplate('ambassadorsCommunityPage'),
      },
    },
  }),

  'campaigns.ambassadors-invites': CampaignsStateFactory({
    data: {
      // TODO: PD-319614 - Remove feature check once AmbassadorsInviteLinks is released
      hasAccess: () =>
        hasFeature(FeatureNames.VibeAmbassadors) &&
        hasFeature(FeatureNames.AmbassadorsInviteLinks) &&
        hasAmbassadorsAccess(),
      title: 'Campaigns: Ambassadors Invites',
    },
    url: '/ambassadors/invites',
    views: {
      main: {
        template: componentNameToTemplate('ambassadorsCommunityPage'),
      },
    },
  }),
};
